import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { TimeAgoPipe } from 'app/core/pipes/time-ago.pipe';
import { SurveysService } from 'app/modules/communication/surveys/surveys.service';
import { ViewSurveyComponent } from 'app/modules/communication/surveys/view-survey/view-survey.component';

@Component({
  selector: 'app-my-active-surveys',
  standalone: true,
  imports: [RouterLink, TimeAgoPipe, MatIconModule, FuseCardComponent, MatProgressSpinnerModule],
  templateUrl: './my-active-surveys.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyActiveSurveysComponent implements OnInit {
  private surveysService = inject(SurveysService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  private matDialog = inject(MatDialog);

  loading = 0;
  surveys: any[] = [];
  error: string = null;

  ngOnInit(): void {
    this.getData();
  }

  openReportModal(survey: any): void {
    this.matDialog.open(ViewSurveyComponent, {
      width: '90vw',
      maxWidth: '1200px',
      data: { surveyId: survey.id, title: survey.title },
      maxHeight: '90vh',
    });
  }

  private getData(): void {
    this.loading++;
    this.surveysService
      .active(false)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          this.surveys = (resp.record || []).slice(0, 5);
          this.loading--;
          this.cdr.markForCheck();
        },
        error: (error: any) => {
          this.error = error.message || 'An error occurred while loading surveys';
          this.loading--;
          this.cdr.markForCheck();
        },
      });
  }
}
